import React from "react"
import ThemeChanger from "../components/themeChanger"

export default (props) => (
  <nav className="navigation"> 
    {/* <Link to="/contact">Contact</Link>  */}
    <ThemeChanger/>
  </nav>
  
)